import styles from "./Button.module.css";

export default function Button({
  variant = "primary",
  size = "md",
  href,
  onClick,
  type = "button",
  fullWidth = false,
  className: extraClassName,
  children,
  ...rest
}) {
  const className = [
    styles.btn,
    styles[variant],
    styles[size],
    fullWidth ? styles.fullWidth : "",
    extraClassName,
  ]
    .filter(Boolean)
    .join(" ");

  if (href) {
    return (
      <a href={href} onClick={onClick} className={className} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type={type} onClick={onClick} className={className} {...rest}>
      {children}
    </button>
  );
}
